import React, { Fragment } from 'react';
import RouteLink from 'view/common/elements/routeLink';

const Dashboard = (props) => {
return ( 
  <div className='pb-40'>
    <div> <RouteLink href='/administration/saveHazards?type=HAZARDS' text='Save Hazards'/></div>
    <div> <RouteLink href='/administration/saveHazards?type=LONGITS' text='Save Longitudinal Hazards'/></div>
    <div> <RouteLink href='/administration/saveHazards?type=DISTRIBUTION' text='Save Distributions'/></div>
    
  </div>
) 
}

export default Dashboard;